import axiosInstance from "../lib/axios";
import { BaseResponse, CustomerResponse } from "../types/responses.type";
import api from "./api";

class CustomersService {
  static async getCustomers(): Promise<BaseResponse<CustomerResponse[]>> {
    try {
      const response = await api.get("/customer");
      return response.data;
    } catch (error: any) {
      if (error.response) {
        return error.response.data;
      }
      return {
        ok: false,
        errorMessage: "Failed to fetch customers",
      };
    }
  }

  static async getCustomer(
    id: number
  ): Promise<BaseResponse<CustomerResponse>> {
    try {
      const response = await api.get(`/customer/${id}`);
      return response.data;
    } catch (error: any) {
      if (error.response) {
        return error.response.data;
      }
      return {
        ok: false,
        errorMessage: "Failed to fetch customer",
      };
    }
  }
}

export default CustomersService;
